import { ResortDetailsPageEvents } from "../../instrumentation/resort-custom-events";
import { ResortImage, ResortImageType, ResortImageFormat, ResortInventory } from "../../models/presentation.model";
import { EventEmitter } from "@angular/core";
import { UserActivityLogger, UserActivityLoggerOptions } from "../../instrumentation/user-activity-logger.service";

export class BaseRoomResult {
    public resultType: string;
    public startBooking: EventEmitter<any> = new EventEmitter();
    public ResortImageType: typeof ResortImageType = ResortImageType;
    public ResortImageFormat: typeof ResortImageFormat = ResortImageFormat;
    public  hasEarnReward: boolean = true;

    public logEvent(resultType: string){
        switch(resultType){
            case 'exact':
            UserActivityLogger.logEvent(ResortDetailsPageEvents.AvailabitlityModalOnBookButtonClicked, {}, UserActivityLoggerOptions.AppInsightsOnly);
            break;
            case 'near':
            UserActivityLogger.logEvent(ResortDetailsPageEvents.AvailabitlityModalNearBookButtonClicked, {}, UserActivityLoggerOptions.AppInsightsOnly);
            break;
          }
    }
    public initiateBooking(inventory:ResortInventory){
        this.logEvent(this.resultType);
        this.startBooking.emit(inventory);
      }
    
    
  public getImagesByType(images: ResortImage[], types: ResortImageType[]): ResortImage[]
  {
      if (images && images.length > 0 && types && types.length > 0)
      {
          images = images.where(i => types.contains(i.imageType)).toArray();
      }

      if (images.length > 0)
          return images;

      let dummyImages: ResortImage[] = [];
      let image: ResortImage = new ResortImage();
      image.description = "!!!!  DESCRIPTION MISSING  !!!!";
      image.fileName = "https://ovsmarketingstorage.blob.core.windows.net/images/image_placeholder_itinerary.jpg";
      image.title = "!!!! TITLE MISSING !!!!";
      image.imagePath = -1;
      image.imageFormat = ResortImageFormat.Image;
      dummyImages.add(image);
      dummyImages.add(image);
      dummyImages.add(image);
      return dummyImages;
  }

  public getImages(images: ResortImage[]): ResortImage[]
  {
      if (images.length > 0)
          return images;

      let dummyImages: ResortImage[] = [];
      let image: ResortImage = new ResortImage();
      image.description = "!!!!  DESCRIPTION MISSING  !!!!";
      image.fileName = "https://ovsmarketingstorage.blob.core.windows.net/images/image_placeholder_itinerary.jpg";
      image.title = "!!!! TITLE MISSING !!!!";
      image.imagePath = -1;
      image.imageFormat = ResortImageFormat.Image;
      dummyImages.add(image);
      dummyImages.add(image);
      dummyImages.add(image);
      return dummyImages;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/room-availability/base-room-result.model.ts